import { ReactNode } from 'react';

import { isValidEmail, isValidPassword, isNonEmpty } from '../helpers/validators';
import { validateEmail } from './validations/validateEmail';
import { validateLogin } from './validations/validateLogin';
import { validatePassword } from './validations/validatePassword';
import authCopy from './authCopy';

const { errors } = authCopy;

export { validateEmail, validatePassword, validateLogin };

export const validateEmailString = (email: string): string | null => {
    if (!isNonEmpty(email)) {
        return 'Email address is required';
    } else if (!isValidEmail(email)) {
        return 'Please enter a valid email address.';
    }
    return null;
};

export function validatePasswordString(password: string): string | null {
    if (!isNonEmpty(password)) {
        return 'Password is required.';
    } else if (!isValidPassword(password)) {
        return 'Please enter a minimum of 5 characters.';
    }
    return null;
}

export function validatePasswords(
    password: string,
    passwordConf: string
): { password: ReactNode; passwordConf: ReactNode } {
    let error;
    if (password !== passwordConf) {
        error = errors.passwordMatch;
    }
    return {
        password: validatePassword(password),
        passwordConf: validatePassword(passwordConf) || error,
    };
}
